// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"01cbc8a2","233":"1eb124f9","255":"e928081e","567":"99441cd2","858":"0b91cb0f","948":"cfb7c68d","969":"0ece0c92"}[chunkId] + ".chunk.css";
};